import gql from 'graphql-tag';

export const updateCheckupReservationForIndividual = gql`
  mutation updateCheckupAppointmentForIndividual($input: UpdateCheckupInput!) {
    updateCheckupAppointmentIndividual(input: $input) {
      id
    }
  }
`;
